import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { SkipLink } from '../a11y/SkipLink';
import { useAuth } from '../../providers/AuthProvider';

/**
 * The contractor job-app shell (0.25.0). Mobile-first: a compact header (brand, "My jobs", sign
 * out) and a single-column main area — the contractor works from a phone on site. Same landmark +
 * focus-on-navigate behavior as the portal/admin shells (WCAG 2.4.3).
 */
export function ContractorLayout() {
  const { principal, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => {
    mainRef.current?.focus();
  }, [location.pathname]);

  return (
    <>
      <SkipLink />
      <header className="app-header">
        <p className="brand">Garage Band LLC — Jobs</p>
        <nav className="app-nav" aria-label="Contractor">
          <ul>
            <li>
              <NavLink to="/contractor" end>
                My jobs
              </NavLink>
            </li>
          </ul>
        </nav>
        <span className="header-spacer" />
        <div className="row">
          {principal && <span className="muted">{principal.displayName}</span>}
          <button
            type="button"
            className="secondary"
            onClick={async () => {
              await logout();
              navigate('/login');
            }}
          >
            Sign out
          </button>
        </div>
      </header>
      <main id="main-content" tabIndex={-1} ref={mainRef} className="contractor-main">
        <Outlet />
      </main>
      <div className="visually-hidden" role="status" aria-live="polite">
        {location.pathname.startsWith('/contractor/jobs/') ? 'Job details' : 'My jobs'} page loaded
      </div>
    </>
  );
}
